<template>
  <v-row justify="center" no-gutters>
    <div class="my-2" v-if="$vuetify.breakpoint.smAndUp">
      <v-btn text rounded class="text-none font-weight-light my-4" @click="goToRouteByName('About')">
        Nosotros
      </v-btn>
      <v-btn text rounded class="text-none font-weight-light my-4" @click="goToRouteByName('Privacy-policies')">
        Politicas de Privacidad
      </v-btn>
      <v-btn text rounded class="text-none font-weight-light my-4" @click="goToRouteByName('Terms-and-conditions')">
        Terminos y Condiciones
      </v-btn>
    </div>

    <v-row no-gutters class="my-2" v-else>
      <v-col cols="12">
        <v-btn text rounded class="text-none font-weight-light" @click="goToRouteByName('About')">
          Nosotros
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn text rounded class="text-none font-weight-light" @click="goToRouteByName('Privacy-policies')">
          Politicas de Privacidad
        </v-btn>
      </v-col>
      <v-col cols="12">
        <v-btn text rounded class="text-none font-weight-light" @click="goToRouteByName('Terms-and-conditions')">
          Terminos y Condiciones
        </v-btn>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
    <v-col class="py-4 text-center gray--text" cols="12">
      <span class="text--primary">{{ new Date().getFullYear() }} — </span>
      <span class="grey--text text--darken-3 font-weight-bold">DevelopIT</span>
    </v-col>
  </v-row>
</template>

<script>
import navigationMixin from '@/mixins/navigation'

export default {
  name: 'ContentFooter',
  mixins: [navigationMixin]
}
</script>
